import React, { useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Modal, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShareSquare, faPlusSquare, faTimes } from '@fortawesome/free-solid-svg-icons';
import './IosInstallPrompt.css';

// You can create simple images/GIFs showing these icons if you want an even better UX
// For now, Font Awesome icons work well.

const IosInstallPrompt = () => {
    const { t } = useTranslation();
    const [isBannerVisible, setIsBannerVisible] = useState(true);
    const [isModalVisible, setIsModalVisible] = useState(false);

    const handleOpenModal = () => setIsModalVisible(true);
    const handleCloseModal = () => setIsModalVisible(false);
    const handleDismissBanner = () => setIsBannerVisible(false);

    // Don't show the banner if it has been dismissed
    if (!isBannerVisible) {
        return null;
    }

    return (
        <>
            {/* The persistent banner at the bottom of the screen */}
            <div className="ios-install-prompt-banner">
                <div className="pwa-prompt-content">
                    <p>{t('ios_prompt_text')}</p>
                    <button className="install-button" onClick={handleOpenModal}>
                        {t('ios_install_guide_button')}
                    </button>
                </div>
                <button className="dismiss-button" onClick={handleDismissBanner}>
                    <FontAwesomeIcon icon={faTimes} />
                </button>
            </div>

            {/* The instructional modal */}
            <Modal show={isModalVisible} onHide={handleCloseModal} centered dialogClassName="ios-install-modal">
                <Modal.Header closeButton>
                    <Modal.Title>{t('ios_modal_title')}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    <p>{t('ios_modal_subtitle')}</p>
                    <div className="ios-step">
                        <p><strong>1.</strong> {t('ios_modal_step1_text')}</p>
                        <FontAwesomeIcon icon={faShareSquare} size="3x" className="my-2 step-icon" />
                    </div>
                    <div className="ios-step">
                        <p><strong>2.</strong> {t('ios_modal_step2_text')}</p>
                        <FontAwesomeIcon icon={faPlusSquare} size="3x" className="my-2 step-icon" />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        {t('ios_modal_close_button')}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default IosInstallPrompt;